function modernizir() {
	if ( ! Modernizr.objectfit ) {
		$('.c__img-object').each(function () {
			$(this).addClass('d-none');
			$(this).siblings('.c__ie-image').removeClass('d-none');
		});
	}	
}